<div class="flex flex-col gap-2" [formGroup]="pharmacyForm()">
  <label for="pharmacyAddress" class="text-[14px] font-[500] hover:cursor-pointer" i18n="@@pharmacyAddressLabel">
    Pharmacy Address
    <span class="text-danger-text">*</span>
  </label>
  <input
    id="pharmacyAddress"
    type="text"
    formControlName="pharmacyAddress"
    placeholder="Enter Pharmacy Address"
    i18n-placeholder="@@adminCreatePharmacyFormAddressPlaceholder"
    class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none"
    [class.border-red-500]="
      pharmacyForm().get('pharmacyAddress')?.invalid && pharmacyForm().get('pharmacyAddress')?.touched
    " />

  @if (pharmacyForm().get("pharmacyAddress")?.invalid && pharmacyForm().get("pharmacyAddress")?.touched) {
    <span class="text-danger-text text-[12px]">
      @if (pharmacyForm().get("pharmacyAddress")?.errors?.["required"]) {
        <span i18n="@@pharmacyAddressRequired">Pharmacy Address is required</span>
      }
      @if (pharmacyForm().get("pharmacyAddress")?.errors?.["minlength"]) {
        <span i18n="@@pharmacyAddressMinlength">Address must be at least 10 characters</span>
      }
      @if (pharmacyForm().get("pharmacyAddress")?.errors?.["maxlength"]) {
        <span i18n="@@pharmacyAddressMaxlength">Address cannot exceed 1000 characters</span>
      }
    </span>
  }
</div>
